import type { ColumnConfig } from '../../../hooks/useTableColumns';

// 公海池列配置
export const publicPoolDefaultColumns: ColumnConfig[] = [
  {
    key: 'index',
    title: '序号',
    width: 60,
    minWidth: 60,
    maxWidth: 80,
    visible: true,
    fixed: 'left',
    order: 0,
    resizable: false,
    draggable: false,
  },
  {
    key: 'contact_name',
    title: '联系人',
    dataIndex: 'contact_name',
    width: 120,
    minWidth: 80,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 1,
    resizable: true,
    draggable: true,
  },
  {
    key: 'contact',
    title: '联系方式',
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    visible: true,
    fixed: false,
    order: 2,
    resizable: true,
    draggable: true,
  },
  {
    key: 'follow_status',
    title: '跟进意向',
    dataIndex: 'follow_status',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 3,
    resizable: true,
    draggable: true,
  },
  {
    key: 'assignee',
    title: '负责人',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 4,
    resizable: true,
    draggable: true,
  },
  {
    key: 'last_follow',
    title: '上次跟进',
    dataIndex: 'last_follow_time',
    width: 110,
    minWidth: 90,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 5,
    resizable: true,
    draggable: true,
  },
  {
    key: 'next_follow_time',
    title: '下次跟进时间',
    dataIndex: 'next_follow_time',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 6,
    resizable: true,
    draggable: true,
  },
  {
    key: 'data_source',
    title: '数据来源',
    dataIndex: 'data_source',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 7,
    resizable: true,
    draggable: true,
  },
  {
    key: 'lead_type',
    title: '线索类型',
    dataIndex: 'lead_type',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 8,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_description',
    title: '案件描述',
    dataIndex: 'case_description',
    width: 200,
    minWidth: 150,
    maxWidth: 400,
    visible: true,
    fixed: false,
    order: 9,
    resizable: true,
    draggable: true,
  },
  {
    key: 'urgency_level',
    title: '紧急程度',
    dataIndex: 'urgency_level',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 10,
    resizable: true,
    draggable: true,
  },
  {
    key: 'person',
    title: '创建人',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 11,
    resizable: true,
    draggable: true,
  },
  {
    key: 'created_at',
    title: '创建时间',
    dataIndex: 'created_at',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 12,
    resizable: true,
    draggable: true,
  },
  {
    key: 'action',
    title: '操作',
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    visible: true,
    fixed: 'right',
    order: 13,
    resizable: false,
    draggable: false,
  },
];

// 我的线索列配置
export const myLeadsDefaultColumns: ColumnConfig[] = [
  {
    key: 'index',
    title: '序号',
    width: 60,
    minWidth: 60,
    maxWidth: 80,
    visible: true,
    fixed: 'left',
    order: 0,
    resizable: false,
    draggable: false,
  },
  {
    key: 'contact_name',
    title: '联系人',
    dataIndex: 'contact_name',
    width: 120,
    minWidth: 80,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 1,
    resizable: true,
    draggable: true,
  },
  {
    key: 'contact',
    title: '联系方式',
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    visible: true,
    fixed: false,
    order: 2,
    resizable: true,
    draggable: true,
  },
  {
    key: 'follow_status',
    title: '跟进意向',
    dataIndex: 'follow_status',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 3,
    resizable: true,
    draggable: true,
  },
  {
    key: 'last_follow',
    title: '上次跟进',
    dataIndex: 'last_follow_time',
    width: 110,
    minWidth: 90,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 4,
    resizable: true,
    draggable: true,
  },
  {
    key: 'next_follow_time',
    title: '下次跟进时间',
    dataIndex: 'next_follow_time',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 5,
    resizable: true,
    draggable: true,
  },
  {
    key: 'data_source',
    title: '数据来源',
    dataIndex: 'data_source',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 6,
    resizable: true,
    draggable: true,
  },
  {
    key: 'lead_type',
    title: '线索类型',
    dataIndex: 'lead_type',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 7,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_description',
    title: '案件描述',
    dataIndex: 'case_description',
    width: 200,
    minWidth: 150,
    maxWidth: 400,
    visible: true,
    fixed: false,
    order: 8,
    resizable: true,
    draggable: true,
  },
  {
    key: 'urgency_level',
    title: '紧急程度',
    dataIndex: 'urgency_level',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 9,
    resizable: true,
    draggable: true,
  },
  {
    key: 'person',
    title: '负责人',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 10,
    resizable: true,
    draggable: true,
  },
  {
    key: 'collaborators',
    title: '协作者',
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 11,
    resizable: true,
    draggable: true,
  },
  {
    key: 'assigned_at',
    title: '认领时间',
    dataIndex: 'assigned_at',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 12,
    resizable: true,
    draggable: true,
  },
  {
    key: 'created_at',
    title: '创建时间',
    dataIndex: 'created_at',
    width: 160,
    minWidth: 140,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 13,
    resizable: true,
    draggable: true,
  },
  {
    key: 'action',
    title: '操作',
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    visible: true,
    fixed: 'right',
    order: 14,
    resizable: false,
    draggable: false,
  },
];
